import { render, staticRenderFns } from "./CustomPageProperty.vue?vue&type=template&id=72851953&"
import script from "./CustomPageProperty.vue?vue&type=script&lang=js&"
export * from "./CustomPageProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports